import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { client } from "../../client";
import { GET_AD_BANNER } from "../admin-ad/Ad.gql";

const AdContainer = styled.div`
  width: 100%;
  margin: 20px 0;
`;

const AdImage = styled.img`
  width: 100%;
  height: auto;
  cursor: pointer;
`;

export const SearchAdvertisement = ({ keyword }) => {
  const [adItem, setAdItem] = useState(null);

  // 키워드별 account ID 매핑
  const accountMapping = {
    발렌타인: 2,
    조니워커: 3,
    로얄살루트: 4,
    카발란: 5,
    발베니: 6,
    글렌피딕: 7,
    달모어: 8,
    맥캘란: 9,
  };

  useEffect(() => {
    const fetchAd = async () => {
      if (!keyword || !accountMapping[keyword]) return;

      try {
        const { data } = await client.query({
          query: GET_AD_BANNER,
          variables: {
            visible: true,
          },
        });

        const filteredAd = data.getAdBannerList
          .filter((ad) => ad.account_id === accountMapping[keyword])
          .slice(0, 1)[0]; // 첫 번째 광고만 사용

        setAdItem(filteredAd);
      } catch (error) {
        console.error("Error fetching ad:", error);
      }
    };

    fetchAd();
  }, [keyword]);

  if (!adItem) return null;

  return (
    <AdContainer
      onClick={() => adItem.url_link && window.open(adItem.url_link, "_blank")}
      style={{ cursor: adItem.url_link ? "pointer" : "default" }}
    >
      <AdImage src={adItem.image_url} alt={`${keyword} 광고`} />
    </AdContainer>
  );
};
